module.exports = __webpack_public_path__ + "static/media/loading.a8d52ca6.gif";